import { render, staticRenderFns } from "./myInvite.vue?vue&type=template&id=4935b7fc&scoped=true"
import script from "./myInvite.vue?vue&type=script&lang=js"
export * from "./myInvite.vue?vue&type=script&lang=js"
import style0 from "./myInvite.vue?vue&type=style&index=0&id=4935b7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4935b7fc",
  null
  
)

export default component.exports